"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _publish = _interopRequireDefault(require("../tracker/publish"));

var _redirect = _interopRequireDefault(require("../../utils/redirect"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _formValidation = require("@insided/deprecated-libs/formValidation");

/* eslint-disable @typescript-eslint/no-this-alias */
define(['app', 'jquery', 'underscore'], function (app, $, _) {
  return app.Marionette.ItemView.extend({
    template: false,
    ui: {
      notifications: '.js-notification',
      submit: '[type="submit"]',
      text_inputs: 'input, textarea',
      all_inputs: 'select, input, textarea'
    },
    options: {
      onSuccessRedirect: true,
      enableSubmitButton: false,
      isTopicEditor: false,
      tagsRequired: false,
      phrases: {
        titlePhrase: "",
        contentPhrase: "",
        categoryPhrase: "",
        tagsPhrase: ""
      },
      labels: {
        connection_error: 'Sorry something went wrong, the request was answered in unexpected way. Please try again.'
      }
    },
    events: {
      submit: 'submitForm',
      'change @ui.all_inputs': 'enableSubmitButton',
      'keyup @ui.text_inputs': 'enableSubmitButton',
      'focus @ui.all_inputs': 'resetErrors'
    },
    components: {
      notifications: {
        name: 'notifications',
        el: '@ui.notifications'
      }
    },
    notifications: false,
    onComponentNotificationsLoaded: function onComponentNotificationsLoaded(instance) {
      this.notifications = instance;
    },
    enableSubmitButton: function enableSubmitButton() {
      // We check if this function is set in the options
      if (this.options.enableSubmitButton) {
        var valid = true;
        var requiredInputs = this.ui.all_inputs.filter('[required]');
        requiredInputs.each(function (_, el) {
          if (valid && !app.$(el).val()) valid = false;
        });
        this.ui.submit.prop('disabled', !valid);
      }
    },
    resetErrors: function resetErrors() {
      this.notifications.triggerMethod('notification:clean');
      this.$el.find('.error').removeClass('error');
    },
    getErrors: function getErrors(errors, parent) {
      var self = this;
      var _errors = [];
      var translations = app.translations ? app.translations.get('ajax-form') : false;

      if (!errors) {
        _errors.push({
          type: 'error',
          msg: translations ? translations.connection_error : this.getOption('labels').connection_error
        });
      } else {
        // Looping to the errors
        _.each(errors, function (error) {
          // Is an object
          if (_.isObject(error) && !_.isArray(error)) {
            _errors = _.union(_errors, self.getErrors(error, parent, true));
          } else if (_.isArray(error)) {
            // is an Array
            _.each(error, function (value) {
              _errors.push({
                type: 'error',
                msg: value
              });
            });
          } else {
            // This should be a string
            _errors.push({
              type: 'error',
              msg: error
            });
          }
        });
      }

      return _errors;
    },
    getSuccessMessages: function getSuccessMessages(messages, parent) {
      var self = this;
      var _messages = []; // Looping to the messages

      _.each(messages, function (message) {
        // Is an object
        if (_.isObject(message) && !_.isArray(message)) {
          _messages = _.union(_messages, self.getSuccessMessages(message, parent, true));
        } else if (_.isArray(message)) {
          // is an Array
          _.each(message, function (value) {
            _messages.push({
              type: 'success',
              msg: value
            });
          });
        } else {
          // This should be a string
          _messages.push({
            type: 'success',
            msg: message
          });
        }
      });

      return _messages;
    },
    onShowInputErrors: function onShowInputErrors(errors, parent) {
      var self = this;
      if (!errors) return false; // Looping to the errors

      _.each(errors, function (error, index) {
        var name = parent + '[' + index + ']'; // Is an object

        if (_.isObject(error) && !_.isArray(error)) {
          self.onShowInputErrors(error, name, true);
        } else {
          var input = self.$el.find('[name*="' + name + '"]');
          if (input.length > 0) input.addClass('error');
        }
      });
    },
    showErrors: function showErrors(errors, parent) {
      this.triggerMethod('show:input:errors', errors, parent);
      this.notifications.triggerMethod('notification:show', this.getErrors(errors));
    },
    showSuccessMessages: function showSuccessMessages(messages) {
      this.notifications.triggerMethod('notification:show', this.getSuccessMessages(messages));
    },
    getRedirectUrl: function getRedirectUrl(msg) {
      var _msg$success,
          _this2 = this;

      var onSuccessRedirect = this.options.onSuccessRedirect;
      if (!onSuccessRedirect) return null;
      if (_.isString(onSuccessRedirect)) return onSuccessRedirect;
      if (msg && _.isString(msg.success)) return msg.success;

      if (msg !== null && msg !== void 0 && (_msg$success = msg.success) !== null && _msg$success !== void 0 && _msg$success.platformSSOURL) {
        var _msg$success2;

        window.addEventListener('pageshow', function () {
          _this2.toggleLoading(false);
        });
        return msg === null || msg === void 0 ? void 0 : (_msg$success2 = msg.success) === null || _msg$success2 === void 0 ? void 0 : _msg$success2.platformSSOURL;
      }

      return window.location.href;
    },
    redirectUser: function redirectUser(redirectUrl, msg) {
      if (redirectUrl) {
        return (0, _redirect.default)(redirectUrl, true);
      }

      if (msg !== null && msg !== void 0 && msg.success) {
        this.toggleLoading(false);
        this.showSuccessMessages(msg.success, this.$el.attr('name'));
      }
    },
    redirectWhenIsReady: function redirectWhenIsReady(url, msg, retries) {
      var _this3 = this;

      if (_.isUndefined(retries)) retries = 0;
      $.get(url).always(function (data, statusText, _jqXhr) {
        var isError = statusText === 'error';

        if (isError && retries < 10) {
          setTimeout(function () {
            _this3.redirectWhenIsReady(url, msg, ++retries);
          }, 1000);
        } else if (isError && retries >= 10) {
          setTimeout(function () {
            _this3.redirectUser('/');
          }, 1000);
          return _this3.showErrors([_this.options.labels.connection_error], _this.$el.attr('name'));
        } else {
          _this3.redirectUser(url, msg);
        }
      });
    },
    checkResponse: function checkResponse(msg) {
      var _this4 = this;

      if (msg !== null && msg !== void 0 && msg.errors) {
        this.toggleLoading(false);
        return this.showErrors(msg.errors, this.$el.attr('name'));
      }

      var redirectUrl = this.getRedirectUrl(msg);
      var isLoginForm = this.ui.submit.is('#login_submit');
      var isRegisterForm = this.ui.submit.is('#register_submit');
      var isForgotPasswordForm = this.ui.submit.is('#forgotPassword_submit');

      if (isLoginForm) {
        window.sessionStorage.setItem('UserLoggedIn', true);
      }

      if (isRegisterForm) {
        window.sessionStorage.setItem('UserRegistered', true);
      }

      if (isForgotPasswordForm) {
        var currentUrl = new URL((0, _absoluteUrlRuntime.resolveUrl)('/'), window.location.origin);
        currentUrl.searchParams.set('passwordReset', 'true');
        return this.redirectUser(currentUrl.toString(), msg);
      }

      if (this.ui.submit.hasClass('button-topic-create')) {
        var _this$$el$find$, _this$$el$find$2, _this$$el$find$3, _this$$el$find$4;

        window.document.dispatchEvent(new window.CustomEvent('topic:submit', {
          detail: {
            category: parseInt(this.$el.find('.editor__subject select').val())
          }
        }));
        var eventData = {
          type: 'Topic Creation Success',
          user_role: (0, _insidedDataStorage.getInsidedData)('user').role,
          topic_title: this.$el.find('#topic_title')[0].value,
          topic_title_characters: this.$el.find('#topic_title')[0].value.length,
          topic_type: (_this$$el$find$ = this.$el.find('#topic_content_type_question')[0]) !== null && _this$$el$find$ !== void 0 && _this$$el$find$.checked ? 'question' : (_this$$el$find$2 = this.$el.find('#topic_content_type_discussion')[0]) !== null && _this$$el$find$2 !== void 0 && _this$$el$find$2.checked || (_this$$el$find$3 = this.$el.find('#topic_content_type_bug')[0]) !== null && _this$$el$find$3 !== void 0 && _this$$el$find$3.checked ? 'discussion' : (_this$$el$find$4 = this.$el.find('#topic_content_type_idea')[0]) !== null && _this$$el$find$4 !== void 0 && _this$$el$find$4.checked ? 'idea' : '',
          topic_url: "".concat(window.location.origin).concat(redirectUrl),
          topic_has_description: true,
          topic_has_category: true,
          topic_has_tags: this.$el.find('#topic_tags')[0].value !== '',
          topic_has_attachments: this.$el.find('.add-attachments li').length > 0
        };

        _publish.default.trackEvent('userevent', eventData, function () {
          _this4.redirectWhenIsReady(redirectUrl, msg);
        });
      } else {
        this.redirectUser(redirectUrl, msg);
      }
    },
    toggleLoading: function toggleLoading(status) {
      status = !!status;

      if (this.ui.submit) {
        this.ui.submit.prop('disabled', status).toggleClass('is-loading', status);
      }
    },
    submitForm: function submitForm(e) {
      e.preventDefault();
      var self = this;
      var $token = this.$el.find('[name$="[_token]"]');
      var formName = this.$el.attr('name');
      this.resetErrors(); // Pre-submit validation for editor topic form

      var isEditorTopicForm = !!this.getOption('isTopicEditor');

      if (isEditorTopicForm) {
        var title = this.$el.find('#topic_title').val();
        var content = this.$el.find('[name="topic[firstPost][content]"]').val();
        var category = this.$el.find('[name="topic[forum]"]').val();
        var tagsRaw = this.$el.find('[name="topic[tags]"]').val();
        var tags = tagsRaw.split(',').filter(function (val) {
          return val !== '';
        });
        var phrases = this.getOption('phrases') || {};
        var validationOptions = {
          titlePhrase: phrases.titlePhrase,
          contentPhrase: phrases.contentPhrase,
          categoryPhrase: phrases.categoryPhrase,
          tagsPhrase: phrases.tagsPhrase,
          tagsRequired: this.getOption('tagsRequired')
        };
        var validationErrors = (0, _formValidation.validateTopicForm)({
          title: title,
          content: content,
          category: category,
          tags: tags
        }, validationOptions);

        if (validationErrors && validationErrors.length > 0) {
          this.showErrors(validationErrors, this.$el.attr('name'));
          return false;
        }
      }

      this.toggleLoading(true);

      if ($token.length) {
        // Refresh the CSRF token
        $.get('/site/_tokens?name=' + formName).done(function (data) {
          // Update the token input value
          $token.val(data._token); // Update the Yip CSRF Token and continue submit form

          self.updateYipCSRFToken(data.yip_csrf_token).doAjaxCall();
        });
      } else {
        this.doAjaxCall();
      }

      return false;
    },
    updateYipCSRFToken: function updateYipCSRFToken(token) {
      app.csrf.models[0].set({
        token: token
      });
      return this;
    },
    doAjaxCall: function doAjaxCall() {
      var self = this;
      var method = this.$el.attr('method') || 'post';
      var data = this.$el.serialize().replace('%26amp%3B', '%26');
      $.ajax({
        method: method,
        data: data,
        url: this.$el.attr('action'),
        success: function success(msg) {
          setTimeout(function () {
            self.checkResponse(msg);
          }, 300);
        },
        error: function error(errors) {
          self.toggleLoading(false);
          self.showErrors(errors.responseText ? JSON.parse(errors.responseText) : {
            generic: ['Something\'s gone wrong']
          });
        }
      });
    },
    onRender: function onRender() {
      if (this.ui.submit.length > 0 && this.ui.submit.prop('tagName') !== 'input') {
        this.ui.submit.append('<div class="loader" />');
      } // Removing the disabled attribute from the submit button with id=login_submit
      // We are keeping the login button disabled until this file is loaded
      // because if this file is not loaded, it would have made a document call to the login page and render JSON response on screen
      // We want the call type to be XHR, so we can handle response at client side


      var loginSubmitButton = this.$el.find('#login_submit');

      if (loginSubmitButton.length > 0) {
        loginSubmitButton.removeAttr('disabled').removeClass('disabled');
      }
    }
  });
});